export default "/images/f464aee158ae846c1c28ee1bccf357de.avif";